module.exports = __webpack_public_path__ + "img/gxjs.0b5c52db.svg";